module.exports = __webpack_public_path__ + "static/media/1029614.9c09b8e5.jpg";